import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button } from '@mui/material'
import useModals from 'src/Hooks/useModals'
import { ChargingCardModel } from '../../api/models/charging-card-model'
import { useHagerBridgePermissions } from '../../../shared/hooks/use-hager-bridge-permissions'

interface ChargingCardsProps {
  installationId: number
  chargingCards: ChargingCardModel[]
  installationHasWallboxes: boolean
}

/**
 * Button shown in "Charging cards" and "Wallboxes" tab. Used to open the dialog where the linking between charging card
 * and wallbox can be made in a matrix/grid UI.
 */
export const ChargingCardToWallboxLinkDialogButton: React.FC<ChargingCardsProps> = ({ installationId, chargingCards, installationHasWallboxes }) => {
  const { t } = useCustomTranslation()
  const { openChargingCardToWallboxLinkModal, openUnmanagedModeOverviewDialog } = useModals()
  const {
    permissions: { wallboxPermissions },
  } = useHagerBridgePermissions()

  if (!wallboxPermissions.assignToken || chargingCards.length === 0 || !installationHasWallboxes) {
    return null
  }

  const isManagedMode = chargingCards.some(card => card.linkedWallboxes.length > 0)

  const onOpenLinkWallboxesDialog = (): void => {
    isManagedMode
      ? openChargingCardToWallboxLinkModal({
          installationId,
        })
      : openUnmanagedModeOverviewDialog({ installationId })
  }

  return (
    <Button
      id="e-mobility-open-charging-card-to-wallbox-link-dialog-button"
      variant="contained"
      onClick={onOpenLinkWallboxesDialog}
      sx={{ marginBottom: 1 }}
    >
      {t('emobility.chargingCards.link-charging-cards-and-wallboxes-button-text')}
    </Button>
  )
}
